import $ from 'jquery';
import LANG from '../lang/prop_en.js';
import { occoApi } from './occoAPI-module.js';
import { getWatermarkSrc, initAccessDataStorage, makeAccessData } from './accessData.js';
import { captureEvents } from '../../../packages/src/api/index.js';
import { prepareUniqPhotoIdsByEventName } from './utils/prepareUniqPhotoIdsByEventName.js';
import { initWaitingNotice } from './waitingNotice.js';
import { ShopifyService } from '../../../packages/src/storefront-cart-api/ShopifyService.js';
import { redirectToPage } from './page-routes.js';

const shopifyService = new ShopifyService();

export const ST_TEXTS = {
  noImages:
    'Oops, looks like you have no images in your album yet.<br> <br>Learn how to link images and videos with your album. ',
  noImagesWithoutLink: 'Oops, looks like you have no images in your album yet.',
  noImagesSelfies:
    'Oops, looks like you have not registered your selfie to unlock your Photo+ images and videos that will appear here. Take a selfie now or scan QR to receive your priceless memories.',
  myTickets: 'My Photo+',
  noImagesSelfiesWA:
    'Oops, looks like you have not yet registered faces we can use to find your images. Please register one good selfie for each member of your party.',
  myWebApp: 'My Album',
  paidMessage:
    'Oops, looks like you do not have a Photo+ Pass yet.<br><br>Get yours now to gain access to high resolution content. ',
  addPhotoPlusMessage:
    'Would you like to add a<br>Photo+ to your shopping<br>cart and gain access to<br>all your digitals?',
  digitalUnlockDupMessage:
    'You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.',
  scanQR: 'Scan the QR code on images or videos of you from the photo viewing kiosk to link your media with this app.',
  helpQR: 'Where can I find the QR of my photo?',
  videoAccess: '🎥 Please ensure that you have enabled the camera access to scan QR code.',
  showMyQR:
    'Scan this QR code to our Photo+ photographer to use it to access your photos at any photo sales locations.',
  showMyQRWA: 'Scan this QR at the kiosk to access your photos, or present it to our roaming photographers when asked.',
  opTutorial: 'FAQs',
  regFace: 'Register a face',
  scanLinkQR: 'Link my photo',
  showMyQRBut: 'Show my Photo ',
  showMyQRButWA: 'Show my QR',
  faceRegTitle: 'Your images and videos will appear here <br>once you have registered your face. ',
  rightFaceMessage:
    'Please make sure that your face is evenly illuminated and fully visible. Maintain neutral expression.',
  noFaceMask: 'NO FACE MASKS',
  shareDownloadRestrict: 'You can share or download only one picture at a time.',
  downloadRestrict: 'You can download only one picture at a time.',
  emptyCart: 'Cart is empty',
  addAnotherProd: 'Add another product',
  addAnotherProdWA: 'Choose an add-on',
  shippingMessage: 'Shipping and discount codes are added at checkout.',
  noVisitDateMessage:
    'Oops, looks like you don’t have a valid ticket yet for your park visit. Link your ticket to enjoy our Photo+ experience.',
  scannedImage: 'Yay, great picture! For Security please confirm. Is this your image?',
  selfieAlbDefTxt: 'Add a selfie or a portrait picture<br> for each member of your party.',
  selfieEmptyTxt: 'There are no recent images in this album.',
  notAvailableYet: "Your Photo+ experience is available during your Genting SkyWorlds' visit.",
  noUidMessage: 'Oops, there was an issue locating your account. Please try again.',
  noSelfiesSugMessage:
    'Oops, looks like you have not registered your selfie. Take a selfie now to receive your priceless memories.',
  shootPhoto: "Look at the camera and click 'Shoot' when ready",
  countDownPhoto: 'Look at the lights',
  renderingVideo: 'Your content is being created. Check your album in a few seconds for an awesome new video!',
  uploadUGCTxt: 'Upload a photo from your camera roll for printing!',
  uploadTMITxtFromQR: 'Take a selfie or upload a portrait from your camera roll.',
  asyncUGCUploadText: 'Your photos will be in your album in a minute!',
  asyncTMIUploadTextFromQR: 'We are working on transforming your image! Refresh this page in a minute or so.',
  deleteRestrictHelp:
    'You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package - please first remove all add-ons from your shopping cart.',
};

// After doing any changes please keep sync this duplicate files in GENTING_APP_HTML and PHOTOALBUM projects
export const REAL_IMAGE_PATH = process.env.IMG_PATH;
export const DEFAULT_SHOOT_HELP_IMG = 'img/remoteShootingDefaultImage.jpg';
export const OCCO_360_VIEWER_PATH = `${REAL_IMAGE_PATH}/360viewer/`;
export const photoPlusVariantId = localStorage.getItem('shopDigitalVariantId');

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatCurrency(currencyCode) {
  if (currencyCode === 'USD') return '$';
  return currencyCode;
}

function formatDecimals(value, digitals = 2) {
  return (Math.round(value * 100) / 100).toFixed(digitals);
}

export function formatPrice({ amount = 0, currencyCode = 'USD' }) {
  return `${formatCurrency(currencyCode)}${formatDecimals(amount)}`;
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

export function showLoading() {
  $('.screenOverlay').show();
  $('#cssload-cupcake').show();
}

export function hideLoading() {
  setTimeout(() => {
    $('#cssload-cupcake').hide();
    $('.screenOverlay').hide();
  }, 100);
}

export const customPopUp = {
  show() {
    $('#customPopUp').modal('show');
  },
  hide() {
    $('#customPopUp').modal('hide');
  },
  html(content) {
    $('#customPopUpBody').html(content || '');
  },
};

export function getParameterByName(name, url) {
  const normalizedName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${normalizedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function alertMessagePopup(text) {
  const opt = {
    title: LANG.occo_album,
    body: text,
  };
  elId('messagePopUpTitle').innerHTML = opt.title ? opt.title : '';
  elId('messagePopUpBody').innerHTML = opt.body ? opt.body : '';
  $('#messagePopUp').modal('show');
}

export function remoteCapture(attId, robotId) {
  showLoading();
  getRobotSettings(robotId, (robotSettings) => {
    hideLoading();
    const RC_TXT1 = robotSettings.RC_TXT1 || ST_TEXTS.shootPhoto;
    const RC_TXT2 = robotSettings.RC_TXT2 || ST_TEXTS.countDownPhoto;
    const RC_TXT3 = robotSettings.RC_TXT3 || ST_TEXTS.renderingVideo;
    const RC_URL1 = robotSettings.RC_URL1 || DEFAULT_SHOOT_HELP_IMG;
    const content = `<div id="shootCont">
        <img src="${RC_URL1}" width="100%" alt="" /><br><br>
        <span class="">${RC_TXT1}</span><br><br>
        <button type='button'  id="shootPhoto" class='btn btn-primary btn-circle btn-xl'  >Shoot</button>
        </div><br>`;
    customPopUp.html(content);
    customPopUp.show();
    $('#shootPhoto').on('click', () => {
      const shootContent = `<div id="cDownCont">
            <span class="" id="hpText">${RC_TXT2}</span><br><br>
            <div id ="cDId" class="cDownLabel">3</div> <br>
            <div id ="closeCont">
              <button class="btn btn-primary btn-sh" onclick="backToHomePage()">Ok</button>
            </div>
            </div><br>`;
      $('#shootCont').html(shootContent);
      $('#closeCont').hide();
      countDown(3, RC_TXT3);
      remoteCaptureReq(attId, robotId);
    });
  });
}

export function uploadFileToS3(file, s3key, s3bucketUrl, s3fields, callbackSuccess) {
  const fd = new FormData();
  fd.append('key', s3key);
  fd.append('acl', 'public-read');
  fd.append('success_action_status', '201');
  let fileType = 'image/jpeg';
  if (file.type && file.type !== '') {
    fileType = file.type;
  }
  fd.append('Content-Type', fileType);
  fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
  fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
  fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
  fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
  fd.append('Policy', s3fields.Policy);
  fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
  fd.append('file', file);

  const xhr = new XMLHttpRequest();

  // xhr.upload.addEventListener("progress", uploadProgress, false);
  xhr.addEventListener(
    'load',
    () => {
      // onSuccess
      let finalPath = `${REAL_IMAGE_PATH}/${s3key}`;
      if (callbackSuccess) {
        if (s3fields.bucket) {
          finalPath = `https://${s3fields.bucket}/${s3key}`;
        }
        callbackSuccess(finalPath);
      }
    },
    false
  );

  // xhr.addEventListener("error", uploadFailed, false);
  // xhr.addEventListener("abort", uploadCanceled, false);

  xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND

  xhr.send(fd);
}

export function elId(id) {
  return document.getElementById(id);
}

export function isValidExtension(extension) {
  return /(jpg|jpeg|png|gif|mp4)$/gi.test(extension);
}

export function updateAppParams(visitDate, eventName = null, callback = () => {}) {
  const appInfoObj = {
    uId: getQueryVariable('uId'),
    vDate: visitDate || getQueryVariable('vDate'),
    lat: getQueryVariable('lat'),
    long: getQueryVariable('long'),
    prePaid: getQueryVariable('prePaid'),
    email: getQueryVariable('email'),
    lang: getQueryVariable('lang'),
    eventName,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/genting-app/add-visit-date-info`,
    data: JSON.stringify({
      app_info_obj: appInfoObj,
    }),
    dataType: 'json',
    success(resp) {
      if (resp?.result) {
        callback(resp.result);
      }
    },
  });
}

export function deleteImagesReq(selectedPhotoIdArray, deleteReason, eventId, keyType, keyValue, callback) {
  const body = {
    photo_id_array: selectedPhotoIdArray,
    delete_reason: deleteReason,
    event_id: eventId,
    key_type: keyType,
    key_value: keyValue,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/photo/list/delete`,
    data: JSON.stringify(body),
    dataType: 'json',
    success(resp) {
      if (resp?.result) {
        callback(null, resp.result);
      }
    },
    error(err) {
      callback(err, null);
    },
  });
}

export function pAttendeeAttachPhotosByQR(attendeeUid, photoUids) {
  return new Promise((resolve) => {
    const body = {
      attendee_uid: attendeeUid,
      photo_uid_array: photoUids,
    };
    $.ajax({
      type: 'POST',
      url: `${process.env.BACKEND_API}/attendee/attach-photos-by-qr-scan`,
      data: JSON.stringify(body),
      dataType: 'json',
      success: resolve,
    });
  });
}

export function attendeeAttachPhotosByQR(attendeeUid, photoUids) {
  showLoading();
  const body = {
    attendee_uid: attendeeUid,
    photo_uid_array: photoUids,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/attendee/attach-photos-by-qr-scan`,
    data: JSON.stringify(body),
    dataType: 'json',
    success() {
      reloadPage();
    },
  });
}

function reloadPage() {
  window.location.reload();
}

export function get360url(normalImageUrl) {
  return `${OCCO_360_VIEWER_PATH}?url=${normalImageUrl}&closeable=false`;
}

export function backToKioskStoreHome() {
  redirectToPage.index({ rawSearch: '?hfb=true' });
}

export function backToHomePage() {
  window.location.href = localStorage.getItem('home');
}

export function showPaidMessage(checkout, fromHome) {
  const photoPlusAlreadyExist = hasPhotoPlus(checkout);
  const isVip = localStorage.getItem('isVip');
  if (!fromHome) {
    if (photoPlusAlreadyExist || isVip === '1') {
      openCheckoutPage(checkout);
      return;
    }
  } else if (photoPlusAlreadyExist || isVip === '1') {
    return;
  }

  const lsMessage = localStorage.getItem('shopDigitalProductMsg');
  const message = lsMessage || ST_TEXTS.addPhotoPlusMessage;
  // if (fromHome) {
  //     message = ST_TEXTS.paidMessage
  // }
  const content = `<div>
    <h6>${message} </h6><br> <br>
     <button id="maybeLaterBtn" type = "button" class = "btn btn-light btn-lg" data-dismiss = "modal" > Maybe Later </button>
     <button id="buyPhotoPlus" type = "button" class = "btn btn-primary btn-lg" > Yes, Upgrade </button></div>`;
  customPopUp.html(content);
  customPopUp.show();
  if (!fromHome) {
    $('#maybeLaterBtn').on('click', () => {
      openCheckoutPage(checkout);
    });
  }
  $('#buyPhotoPlus').on('click', () => {
    customPopUp.hide();
    buyPhotoPlusGlob(checkout);
  });
}

function hasPhotoPlus(checkout) {
  if (!photoPlusVariantId || photoPlusVariantId.trim().length === 0) return true;
  let isPhotoPlus = false;
  const prodPlusVariantIdNorm = shopifyService.normalizeProductVariantId(photoPlusVariantId);
  const lineItemList = checkout.lineItems;
  for (const lineItem of lineItemList) {
    const variantArr = JSON.parse(getCustomAttribute(lineItem, '_variantArr'));
    for (let i = 0; i < variantArr.length; i += 1) {
      if (variantArr[i] && variantArr[i].id === prodPlusVariantIdNorm) {
        isPhotoPlus = true;
        break;
      }
    }
  }
  return isPhotoPlus;
}

export function isDigitalPack(id) {
  const prodPlusVariantIdNorm = shopifyService.normalizeProductVariantId(photoPlusVariantId);
  return id === prodPlusVariantIdNorm;
}

export function alertDigitalPackDuplicationAndRedirect(variants, checkout) {
  if (hasDigitalPack() && hasPhotoPlus(checkout)) {
    const lsMessage = localStorage.getItem('shopDigitalProductDupMsg');
    const message = lsMessage || ST_TEXTS.digitalUnlockDupMessage;
    const content = `<div>
        <h6>${message} </h6><br> <br>
        <button id="buttonOK" type="button" class="btn btn-primary btn-lg"> OK </button></div>`;
    customPopUp.html(content);
    customPopUp.show();
    $('#buttonOK').on('click', () => {
      window.location.href = 'cart.html';
    });
    return true;
  }
  return false;

  function hasDigitalPack() {
    if (Array.isArray(variants)) {
      return variants.findIndex((variant) => isDigitalPack(variant.id)) > -1;
    }
    const variantId = variants;
    return isDigitalPack(variantId);
  }
}

export function alertIfNoEvent(eventName) {
  if (!eventName || eventName === false || eventName === 'false' || eventName === null || eventName === 'null') {
    alert('eventName is not provided.');
    return true;
  }
  return false;
}

export function buyPhotoPlusGlob(checkout) {
  const photoPlusAlreadyExist = hasPhotoPlus(checkout);
  if (photoPlusAlreadyExist) {
    openCheckoutPage(checkout);
    return;
  }

  const eventName = localStorage.getItem('eventName');
  // Event name is critical parameter and must be provided correctly
  if (alertIfNoEvent(eventName)) {
    return;
  }

  const lineItems = [];
  const attUid = localStorage.getItem('attUidWA') || getQueryVariable('uId');
  const prodVariantId = shopifyService.normalizeProductVariantId(photoPlusVariantId);
  const lineItem = {
    variantId: prodVariantId,
    quantity: 1,
  };

  lineItem.customAttributes = [];
  const variantArr = [];
  const newVariant = {};
  newVariant.productTitle = '';
  newVariant.pid = 0;
  newVariant.eventName = eventName;
  newVariant.id = prodVariantId;
  newVariant.attendeeUid = attUid;
  newVariant.action = 'unlock';

  variantArr.push(newVariant);
  lineItem.customAttributes.push({
    key: '_variantArr',
    value: JSON.stringify(variantArr),
  });
  lineItems.push(lineItem);
  shopifyService.addLineItems(checkout.id, lineItems).then(openCheckoutPage);
}

export function getCustomAttribute(lineItem, customAttName) {
  for (const customAtt of lineItem.customAttributes) {
    if (customAtt.key === customAttName) {
      return customAtt.value;
    }
  }
  return null;
}

function openCheckoutPage(checkout) {
  window.location = checkout.webUrl;
}

function remoteCaptureReq(attendeeUid, robotId) {
  const body = {
    attendee_uid: attendeeUid,
    aws_robot_name: robotId,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/attendee/make-a-shoot`,
    data: JSON.stringify(body),
    dataType: 'json',
    success() {},
  });
}

function countDown(number, RC_TXT3) {
  let count = number;
  if (count >= 0) {
    $('#cDId').html(count);
    count -= 1;
    setTimeout(() => {
      countDown(count, RC_TXT3);
    }, 1000);
  } else {
    $('#cDId').html('');
    $('#closeCont').show();
    $('#hpText').html(RC_TXT3);
  }
}

export function trackPhotoEvent({ activityName, photoId, robotId = null, attendeeUid }) {
  const activityType = 'info';
  occoApi.activityCreateByRobotId(robotId, photoId, activityName, activityType, attendeeUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

export function trackListOfPhotoEvent({ activityName, listOfPhotoId, robotId = null, attendeeUid }) {
  const activityType = 'info';
  occoApi.activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, attendeeUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

function getRobotSettings(robotId, callback) {
  const body = {
    aws_robot_name: robotId,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/robot/settings/retrieve`,
    data: JSON.stringify(body),
    dataType: 'json',
    success(resp) {
      let settings = {};
      if (resp?.result?.state) {
        settings = resp.result.state;
      }
      callback(settings);
    },
  });
}

export function fromUrlFilename(url) {
  if (!url) {
    return url;
  }
  return url.split('/').pop();
}

export function isValidEmail(email, multi = false) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address
  let validEmail = true;
  if (multi) {
    const emails = email.split(',');
    if (emails && emails.length > 1) {
      $.each(emails, (index, value) => {
        if (!emailRegex.test(value)) {
          return false;
        }
      });
    } else {
      validEmail = emailRegex.test(emails[0]);
    }
  } else {
    validEmail = emailRegex.test(email);
  }
  return validEmail;
}

export function showAlert(text) {
  alert(text);
}

export async function createAttendee({ eventCode, name, email, phoneNumber }) {
  return new Promise((resolve) => {
    const data = {
      eventCode,
      attendeeName: name,
      attendeeEmail: email,
      attendeePhoneNumber: phoneNumber,
    };
    $.ajax({
      type: 'POST',
      url: `${process.env.BACKEND_API}/attendee/create-and-send-email`,
      data: JSON.stringify(data),
      dataType: 'json',
      success: resolve,
    });
  });
}

export function deleteRestrictionHelpMessage() {
  const content = `<div>${ST_TEXTS.deleteRestrictHelp}</div><br>
                     <button  type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal" > Ok </button>`;
  customPopUp.html(content);
  customPopUp.show();
}

/**
 * the possible description format for collection:
 * {
 *      "product_list":{
 *              "7825764122868": 3,
 *              "7825956569332":1
 *      },
 *      "pack_product" : "7826002608372",
 *      "hide_from_kiosk_ids":[
 *          "ks031",
 *          "ks210"
 *      ],
 *      "show_on_webapp": "yes"
 * }
 * Note: hide_from_kiosk_ids covers the "show on kiosk" functionality
 * Important: for webapp "hide_from_kiosk_ids" is ignored
 */
export function getCollectionOrProductVisibility(checkingObj) {
  let isObjectVisible = true;
  const description = checkingObj.desc || checkingObj.description;
  const isVip = localStorage.getItem('isVip') === '1';
  const objType = checkingObj.desc ? 'product' : 'collection';
  if (description && description.length > 15) {
    try {
      const descObj = JSON.parse(description);
      if (descObj?.show_on_webapp) {
        if (descObj.show_on_webapp.toLowerCase() === 'no') {
          isObjectVisible = false;
        }
      }
      isObjectVisible = isObjectVisible && !(isVip && descObj?.hide_for_vip);
    } catch (error) {
      console.log(`Wrong JSON format in ${objType} description: `, description);
    }
  }
  return isObjectVisible;
}

export function prepareTagsFilter(desc) {
  if (!desc || !isJsonString(desc)) return { acceptTags: [], denyTags: [] };
  const params = JSON.parse(desc);
  const acceptTags = params.require_tag || [];
  const denyTags = params.deny_tag || [];
  return { acceptTags, denyTags };
}

export function isVisibleCombo(comboObj) {
  return getCollectionOrProductVisibility(comboObj);
}

export function getProductTagType(product) {
  const prodDesc = product.desc || product.description;
  let prodDescJson = {};
  const resProdTypes = {
    acceptTags: [],
    denyTags: [],
  };
  if (prodDesc) {
    try {
      prodDescJson = JSON.parse(prodDesc);
    } catch (e) {
      prodDescJson = {};
    }
  }
  let productAcceptTags = [];
  let productDenyTags = [];
  if (prodDescJson.require_tag) {
    productAcceptTags = productAcceptTags.concat(prodDescJson.require_tag);
    resProdTypes.acceptTags = productAcceptTags;
  }
  if (prodDescJson.deny_tag) {
    productDenyTags = productDenyTags.concat(prodDescJson.deny_tag);
    resProdTypes.denyTags = productDenyTags;
  }
  return resProdTypes;
}

export function getComboTagType(collection) {
  const comboType = {
    comboAcceptTags: [],
    comboDenyTags: [],
  };
  const { products } = collection;
  for (let p = 0; p < products.length; p += 1) {
    // collects combo printable tags
    const prodTags = getProductTagType(products[p]);
    if (prodTags.acceptTags.length > 0) {
      comboType.comboAcceptTags = comboType.comboAcceptTags.concat(prodTags.acceptTags);
    }
    if (prodTags.denyTags.length > 0) {
      comboType.comboDenyTags = comboType.comboDenyTags.concat(prodTags.denyTags);
    }
  }
  return comboType;
}

export function initThrottle() {
  const throttleData = {};

  // eslint-disable-next-line no-prototype-builtins
  const isEnabled = (key) => throttleData.hasOwnProperty(key) && throttleData[key];
  const disable = (key) => {
    throttleData[key] = false;
  };
  const enable = (key) => {
    throttleData[key] = true;
  };

  const disableOverTime = (key, milliseconds) => setTimeout(() => disable(key), milliseconds);

  return (id, cb, timeout) => {
    if (!isEnabled(id)) {
      cb();
      enable(id);
      disableOverTime(id, timeout);
    }
  };
}

export function isPrintable(variant) {
  return variant.poolPrefix !== null && variant.poolPrefix !== undefined && variant.poolPrefix !== '';
}

export function isNonPrintable(variant) {
  return !isPrintable(variant);
}

function isUnlockMedia(variant) {
  return variant.unlockMedia !== null && variant.unlockMedia !== undefined && variant.unlockMedia !== '';
}

export function isSelectable(variant) {
  return isPrintable(variant) || isUnlockMedia(variant);
}

export function isNonSelectable(variant) {
  return !isSelectable(variant);
}

export function isValidForPrint(src, tags) {
  return /(jpg|jpeg|png)$/gi.test(fileExt(src)) || (src.includes('uokg5o') && tags.acceptTags.includes('uokg5o'));

  function fileExt(path) {
    return path.split('.').pop().toLowerCase();
  }
}

export function isValidForPrintAndUnlock(src, tags, unlockMedia) {
  return (
    /(jpg|jpeg|png)$/gi.test(fileExt(src)) ||
    unlockMedia === 'unlock_media' ||
    localStorage.getItem('isUnlockMedia') === 'true' ||
    (src.includes('uokg5o') && tags.acceptTags.includes('uokg5o'))
  );

  function fileExt(path) {
    return path.split('.').pop().toLowerCase();
  }
}


export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const accessDataStorage = initAccessDataStorage();
accessDataStorage.getData(makeAccessData());

export function preparePhotosForDisplay(photos, tags, unlockMedia) {
  return photos
    .filter(
      (photo) =>
        isValidForPrintAndUnlock(photo.full_path, tags, unlockMedia) &&
        checkProductTagTypeAndImageTag(photo.thumb_full_path, tags)
    )
    .map((photo) => ({ ...photo, watermarkSrc: getWatermarkSrc(accessDataStorage.getData(), photo) }));
}

export function checkProductTagTypeAndImageTag(imgUrl, prodTag) {
  if (
    !prodTag ||
    (!prodTag.acceptTags && !prodTag.denyTags) ||
    (prodTag.acceptTags.length === 0 && prodTag.denyTags.length === 0)
  ) {
    return true;
  }

  let fileName = '';
  if (imgUrl) {
    fileName = fromUrlFilename(imgUrl);
  }

  let isPassedAccept = prodTag.acceptTags.length === 0;
  let isPassedDeny = true;

  for (let i = 0; i < prodTag.acceptTags.length; i += 1) {
    if (fileName.indexOf(prodTag.acceptTags[i]) !== -1) {
      isPassedAccept = true;
      break;
    }
  }

  if (isPassedAccept) {
    for (let i = 0; i < prodTag.denyTags.length; i += 1) {
      if (fileName.indexOf(prodTag.denyTags[i]) !== -1) {
        isPassedDeny = false;
        break;
      }
    }
  }
  return isPassedAccept && isPassedDeny;
}

export const pluck = (arr, ...keys) =>
  keys.length > 1 ? arr.map((i) => keys.map((k) => i[k])) : arr.map((i) => i[keys[0]]);

export function checkProductTagTypeForAllImages(img_paths, prodTags) {
  if (
    !prodTags ||
    (!prodTags.acceptTags && !prodTags.denyTags) ||
    (prodTags.acceptTags.length == 0 && prodTags.denyTags.length == 0) ||
    !img_paths ||
    img_paths.length === 0
  ) {
    return true;
  }
  let showProduct = false;
  for (const i in img_paths) { // eslint-disable-line
    showProduct = showProduct || checkProductTagTypeAndImageTag(img_paths[i], prodTags);
  }
  return showProduct;
}

export function checkProductTagTypeForAllImagesWrapper(variant) {
  return checkProductTagTypeForAllImages(
    pluck(JSON.parse(localStorage.getItem('allPhotos')), 'full_path'),
    prepareTagsFilter(variant.desc)
  );
}

export function checkComboProductsTagTypeForAllImages(combo, alaCarteId, img_paths) {
  let showComboAfterTagFiltering = !combo.id.includes(alaCarteId);
  const prodTags = {};
  for (const i in combo.products) { // eslint-disable-line
    prodTags.acceptTags = getProductTagType(combo.products[i]).acceptTags;
    prodTags.denyTags = getProductTagType(combo.products[i]).denyTags;
    showComboAfterTagFiltering = combo.id.includes(alaCarteId)
      ? showComboAfterTagFiltering || checkProductTagTypeForAllImages(img_paths, prodTags)
      : showComboAfterTagFiltering && checkProductTagTypeForAllImages(img_paths, prodTags);
  }
  return showComboAfterTagFiltering;
}

export function transformIdsToPhotos(ids, photos) {
  return ids.map((photoId) => photos.find((photo) => photo.id === photoId)).filter((photo) => Boolean(photo));
}

export function getCurrentFormModelItem(formModel, currentStep) {
  return formModel[currentStep - 1];
}

export function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

export function isAndroid() {
  return /android/i.exec(navigator.userAgent);
}

export function isIPhone() {
  return /(iPad)|(iPhone)|(iPod)/i.exec(navigator.userAgent);
}

export function isMobile() {
  return isAndroid() || isIPhone();
}

export function renameFileNameMutate(file, newName) {
  Object.defineProperty(file, 'name', {
    writable: true,
    value: newName,
    configurable: true,
  });
}
export function getUUID() {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export const preparePhotoIdsUniqueDownloadEvent = prepareUniqPhotoIdsByEventName('download');
export const preparePhotoIdsUniqueShareEvent = prepareUniqPhotoIdsByEventName('share');

export const makeUniqEvent = ({ eventId, eventName, photoId, eventCode, attendeeUid }) => ({
  EventName: `Unique${capitalize(eventName)}`,
  EventType: 'info',
  EventSource: 'WebApp',
  AttendeeUid: attendeeUid,
  PhotoId: photoId,
  EventId: eventId,
  EventCode: eventCode,
  Count: 1,
});

const waitingNotice = initWaitingNotice();

const downloadSingleFile = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const urlAsArray = url.split('/');
  const fileName = urlAsArray[urlAsArray.length - 1];
  const a = document.createElement('a');
  a.download = fileName;
  a.style.display = 'none';
  a.href = URL.createObjectURL(blob);
  a.addEventListener('click', () => {
    setTimeout(() => {
      URL.revokeObjectURL(a.href);
      a.remove();
    }, 1000);
  });
  document.body.append(a);
  a.click();
};

export const multipleDownload = async (photos, eventData, attendeeUid) => {
  const title = 'Photos';

  // Track download events for each photo
  const photoIdList = photos.map((photo) => photo.id);
  trackListOfPhotoEvent('Download', photoIdList, null);

  // Prepare and capture unique download events
  const preparedPhotos = preparePhotoIdsUniqueDownloadEvent(photos.map((photo) => photo.id)).map((photoId) =>
    makeUniqEvent({ photoId, eventId: eventData.id, eventName: 'download', eventCode: eventData.name, attendeeUid })
  );
  captureEvents(preparedPhotos);

  const downloadFiles = async (urls) => {
    waitingNotice.text('Downloading files.<br/>Please be patient.');
    waitingNotice.show();

    try {
      if (isIPhone()) {
        // Check sharing capability before downloading
        if (!navigator.canShare) {
          alert('Your browser does not support sharing multiple files.');
          waitingNotice.hide();
          return;
        }

        // iOS handling using navigator.share
        const files = await Promise.all(
          urls.map(async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            const urlAsArray = url.split('/');
            const fileName = urlAsArray[urlAsArray.length - 1];
            return new File([blob], fileName, { type: blob.type });
          })
        );

        await navigator.share({
          files,
          title,
        });
      } else {
        // Android and other devices handling
        await Promise.all(urls.map(downloadSingleFile));
      }
    } catch (error) {
      console.error('Error downloading files:', error);
    } finally {
      waitingNotice.hide();
    }
  };

  await downloadFiles(photos.map((photo) => photo.full_path));
};
